/**
 * this Object write for firebase configuration
 */
export const firebaseConfig = {
    apiKey: 'AIzaSyDFTb_O5nKg-3gFTojhAEJ407CDTDax9tw',
    authDomain: 'qplease-sandbox.firebaseapp.com',
    databaseURL: 'https://qplease-sandbox-default-rtdb.firebaseio.com',
    projectId: 'qplease-sandbox',
    storageBucket: 'qplease-sandbox.appspot.com',
    messagingSenderId: '296414901828',
    appId: '1:296414901828:web:136e6ca2958296bfc22e11',
    measurementId: 'G-KTB67SJBQ0'
}
